<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-quality-high</v-icon>{{$t('profile.quality.layers')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <QualityLayerForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import QualityLayerForm from '../../components/qualitylayer/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'QualityLayer';

const { mapFields } = createHelpers({
  getterType: 'qualitylayer/getField',
  mutationType: 'qualitylayer/updateField'
});

export default {
  name: 'QualityLayerCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    QualityLayerForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('qualitylayer', ['create', 'reset'])
  }
};
</script>
